




function Home() {
    return <>
      <h1>Reciclajes Recial</h1>
      <p>Web-based Application React in Progress</p>
    </>;
  }

export default Home;